<div [formGroup]="form">
  <mtn-text-field [form]="form" controlName="confirmation"
                  [placeholder]="'confirmation.confirmDelete' | translate"
                  [isRequired]="true">
  </mtn-text-field>
</div>
